import React from 'react';
import { ArrowDownIcon, ArrowUpRightIcon } from 'lucide-react';
import { usePortal } from '../contexts/PortalContext';
import type { FileRow } from '../types/portal';
interface FileListProps {
  rows: FileRow[];
}
export function FileList({
  rows
}: FileListProps) {
  const {
    notify,
    openDeliverable
  } = usePortal();
  return <ul className="m-0 list-none p-0" data-id="element-91" data-mp="1fbh8mgm3ze3l">
      {rows.map(row => <li key={row.id} className="border-b border-rule" data-id="element-92" data-mp="rk23kg2y6ion">
          <button type="button" onClick={() => {
        if (row.opensInPortal) {
          openDeliverable(row.id);
          return;
        }
        notify(row.action === 'Download' ? `Simulated · ${row.label} would download from Google Drive` : `Simulated · ${row.label} would open in Google Drive`);
      }} className="group flex w-full items-baseline justify-between gap-6 py-6 text-left transition-colors duration-150 ease-out hover:text-graphite" data-id="element-93" data-mp="riinoql7e9ne">
            <span className="min-w-0" data-id="element-94" data-mp="2f1z5bwbwztt7">
              <span className="block font-display text-2xl leading-none sm:text-3xl" data-id="element-95" data-mp="2k23d8xyrbg7t">
                {row.label}
              </span>
              <span className="label-sm mt-3 block text-mute" data-id="element-96" data-mp="2oueogwyy6ofo">{row.meta}</span>
            </span>
            <span className="label flex shrink-0 items-center gap-2 text-graphite" data-id="element-97" data-mp="2suf3aipyl1n9">
              {row.action}
              {row.action === 'Download' ? <ArrowDownIcon className="h-3.5 w-3.5 transition-transform duration-150 ease-out group-hover:translate-y-0.5" strokeWidth={1.25} data-id="element-98" data-mp="2138yhozamfrn" /> : <ArrowUpRightIcon className="h-3.5 w-3.5 transition-transform duration-150 ease-out group-hover:translate-x-0.5" strokeWidth={1.25} data-id="element-99" data-mp="2a5i88cmqm53z" />}
            </span>
          </button>
        </li>)}
    </ul>;
}